<template>
  <div>
    <div class="box" :value="confirmEvent">
      <div style="margin:20px 0px 0px 25px; font-size: 14px;">章节名称：{{this.info.lessonName}}</div>
      <div v-if="this.info.lessonType != '01'" class="border-box">
        <BInputTimeRange
          v-model="time"
          from-text="上课期间:"
          to-text="至"
          @startTimeChange="startDateChange"
          @endTimeChange="endDateChange"
        />
      </div>
      <div v-else class="border-box">
        <BInputDateRange
          v-model="time"
          from-text="上课期间:"
          to-text="至"
          @startDateChange="startDateChange"
          @endDateChange="endDateChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BInputDateRange from "@/components2/BInputDateRange";
import BInputTimeRange from "@/components2/BInputTimeRange";
import Vue from "vue";
import { infoSave} from "@/api/classManagement";
export default {
  name: "EditTimeDialog",
  props: {
    data: Object,
    confirmEvent: Boolean
  },
  components: {
    BInputTimeRange,
    BInputDateRange,
  },
  watch: {
    confirmEvent() {
      if (this.confirmEvent === true || this.confirmEvent === null) {
         this.save();
      }
    },
  },
  data() {
    return {
      lessonId: null,
      classId: null,
      lessonName: "",
      time: {
        from: "",
        to: "",
      },
      info: {},
      returnData: "",
    };
  },
  mounted() {
    if (
      this.data !== null &&
      this.data !== "" &&
      this.data !== undefined
    ) {
      this.info = this.data;
      this.time.from = this.info.startTime
      this.time.to = this.info.endTime
    }
  },
  methods: {
    
    startDateChange(value) {
      this.time.from = value;
    },
    endDateChange(value) {
      this.time.to = value;
    },
    // 向父页面返回结果
    result(value) {
      this.returnData = value;
      this.$emit("ok", this.returnData);
    },
    
    async save() {
      var param = {}
      if(this.info.lessonType == '01') {
        
        if(this.time.from == "") {
          this.time.from = this.info.startTime+" 00:00"
        } else {
          this.time.from = this.time.from+" 00:00"
        }
        if(this.time.to == "") {
          this.time.to = this.info.endTime+" 00:00"
        } else {
          this.time.to = this.time.to+" 00:00"
        }
        param = {
          lessonId: this.info.lessonId,
          classId: this.info.classId,
          startTime: this.time.from,
          endTime: this.time.to,
        };
      } else {
        if(this.time.from == "") {
          this.time.from = this.info.startTime+" 00:00"
        } else {
          this.time.from = this.time.from.substring(0,10)+" "+ this.time.from.substring(11,16)
        }
        if(this.time.to == "") {
          this.time.to = this.info.endTime+" 00:00"
        } else {
          this.time.to = this.time.to.substring(0,10)+" "+ this.time.to.substring(11,16)
        }
        param = {
          lessonId: this.info.lessonId,
          classId: this.info.classId,
          startTime: this.time.from,
          endTime: this.time.to,
        };
      }
      console.log("param",param)
      const data = await infoSave(param);
      console.log("infoSave",data)
      if (data.code === 0) {
        Vue.prototype.$vsnackbar.show(data.msg);
        // （保存成功）向主页面返回信息
        this.result(1);
        // 关闭弹层
        this.$emit("input", false);
      } else {
        Vue.prototype.$valertbar.show(data.msg);
        // 返回失败
        this.result(0);
      }
    },
  },
};
</script>

<style scoped>
.box {
  display: flex;
  flex-direction: column;
}

.border-box {
  display: flex;
  width: 600px;
  height: 100px;
}

.inner-box {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
  position: relative;
  justify-content: center;
}

</style>
